import { render, staticRenderFns } from "./community.vue?vue&type=template&id=cbb7fc8a&scoped=true"
import script from "./community.vue?vue&type=script&lang=js"
export * from "./community.vue?vue&type=script&lang=js"
import style0 from "./community.vue?vue&type=style&index=0&id=cbb7fc8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb7fc8a",
  null
  
)

export default component.exports